import { signInWithPopup, signOut } from "firebase/auth";
import { auth, googleProvider } from "./firebase";

/**
 * Signs in the user with Google using a popup.
 * @returns {Promise<object>} The Firebase user object upon successful authentication.
 * @throws Will throw an error if the Google sign-in process fails.
 */
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return result.user;
  } catch (error) {
    // Log detailed error information for debugging
    console.error("Google Sign-In Error Code:", error.code);
    console.error("Google Sign-In Error Message:", error.message);
    if (error.customData && error.customData.email) {
      console.error("Google Sign-In Attempted Email:", error.customData.email);
    }
    // It's good practice to throw a more generic error or a custom error type to the caller
    // to avoid exposing too much detail from the Firebase error object directly to UI components.
    throw new Error("Google Sign-In failed. Please try again.");
  }
};

/**
 * Signs out the current user.
 * @throws Will throw an error if the sign-out process fails.
 */
export const signOutUser = async () => {
  try {
    await signOut(auth);
    // Sign-out successful. AuthContext will handle redirect or state updates.
  } catch (error) {
    console.error("Error signing out: ", error);
    throw new Error("Sign-out failed. Please try again.");
  }
};
